<script lang="ts" setup>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'
import { Bar } from 'vue-chartjs'

const props = defineProps({
  dataSet: {} as ChartData<"bar", number[], string>,
  options: {},
  chartStyle: {}
});

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
</script>

<template>
    <Bar :data="props.dataSet" :options="props.options" :style="props.chartStyle"/>
</template>